"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = (function () {
    function default_1(_keys) {
        if (_keys === void 0) { _keys = {}; }
        this._keys = _keys;
    }
    default_1.prototype.save = function (keys) {
        this._keys = keys || {};
        return Promise.resolve();
    };
    default_1.prototype.load = function () {
        return Promise.resolve(this._keys);
    };
    return default_1;
}());
exports.default = default_1;
//# sourceMappingURL=memory-store.js.map


// WEBPACK FOOTER //
// ../src/memory-store.ts